import { useState } from "react";
import { AppPTORequests } from "../app-time-off/AppPTORequests";

type DCPTOHistoryProps = {
    data: any;

}

export const DCPTOHistory = ({data}: DCPTOHistoryProps) => {
    return (
        <AppPTORequests dynamicContext={{ employeeRecordIds: data.employeeRecordIds }} />
    )
}